import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload, faStoreAlt } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { ModalButton } from "../../../ui/buttons";
import { ContentKpi, IconKpi, KPIcard } from "../../../ui/kpis";
import { CustomLabel } from "../../../ui/labels";
import { configDatePickerLenguage } from "../../../components/RelevosInfoGeneral/utils";
import { exportRegistroDeVisitas, visitasKpis } from "../../../services/clientesServices";
import useFetcher from "../../../hooks/useFetcher";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { humanDateFormat } from "../../../../config/constants";

const RegistroDeVisitasKPIModal = ({ toggle, isOpen }) => {
  const unMesAtras = moment().subtract(30, "days").format("DD/MM/YYYY");
  const fechaActual = moment().format("DD/MM/YYYY");
  const locale = configDatePickerLenguage();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [params, setParams] = useState([{ startDate: moment().subtract(30, "days").format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") }]);
  const [kpis, isLoadingKpis] = useFetcher(visitasKpis, params);
  const [exportRegistrosDeVisitas, setExportRegistrosDeVisitas] = useState(false);

  // funcion para exportar
  const handleExportar = async () => {
    if (startDate && endDate) {
      setExportRegistrosDeVisitas(true);
      try {
        toast.success("Su solicitud de exportación está siendo procesada...");
        const blob = await exportRegistroDeVisitas(params[0]);
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        const filename = `Visitas-${moment().format(humanDateFormat)}.csv`;
        link.href = url;
        link.setAttribute("download", filename);
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        toast.error(`Error al exportar el archivo`);
      }

      setExportRegistrosDeVisitas(false);
    }
    toggle();
  };

  // actualiza el rango de fechas con los ultimos 30 dias
  useEffect(() => {
    setDateRange([moment(unMesAtras, "DD/MM/YYYY").toDate(), moment(fechaActual, "DD/MM/YYYY").toDate()]);
  }, []);

  // formatea la fecha para los params
  useEffect(() => {
    if (startDate && endDate) {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      setParams([{ startDate: start, endDate: end }]);
    }
  }, [startDate, endDate]);

  // formatea el valor del rango de fechas
  const getDataRangeValue = (inputStartDate, inputEndDate) => {
    const start = inputStartDate ? moment(inputStartDate).format("DD/MM/YYYY") : "";
    const end = inputEndDate ? moment(inputEndDate).format("DD/MM/YYYY") : "";
    return `${start} - ${end}`;
  };

  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal isOpen={isOpen} centered style={{ maxWidth: "450px", width: "50%" }}>
        <ModalHeader className="border-0 height-50" toggle={toggle} style={{ backgroundColor: "#f8f8f8", borderRadius: "8px" }} />
        <ModalBody style={{ backgroundColor: "#f8f8f8", borderRadius: "8px" }}>
          <>
            <FontAwesomeIcon icon={faFileDownload} color="#293134" size="3x" className="mb-2" />
            <div className="col-md-12">
              <StylesDatePicker className="mb-3 w-100">
                <CustomLabel htmlFor="fechaTC"> Rango de fechas </CustomLabel>
                <DatePicker
                  locale={locale}
                  id="fecha"
                  className="digits date-input"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  value={getDataRangeValue(startDate, endDate)}
                />
              </StylesDatePicker>
            </div>
            <div className="col-md-10">
              <BlurSpinner isLoading={isLoadingKpis}>
                <KPIcard className="card">
                  <div className="card-body d-flex align-items-center justify-content-start mb-2 mx-10 pb-0">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <IconKpi>
                        <FontAwesomeIcon icon={faStoreAlt} width="50px" height="50px" />
                      </IconKpi>
                      <ContentKpi>
                        <h3>Registro de Visitas</h3>
                        <div className="d-flex align-items-end justify-content-start">
                          {kpis ? (
                            <>
                              <p>{kpis}</p>
                            </>
                          ) : (
                            <p>-</p>
                          )}
                        </div>
                      </ContentKpi>
                    </div>
                  </div>
                </KPIcard>
              </BlurSpinner>
            </div>
          </>
          <ModalFooter className="border-0 w-100">
            <div className="d-flex justify-content-end">
              <ModalButton className="btn px-2 py-1 text-center mr-2" onClick={toggle} type="button">
                Cerrar
              </ModalButton>
              <ModalButton
                className="btn px-2 py-1 text-center"
                style={{ backgroundColor: "#F0292A", color: "white" }}
                onClick={() => {
                  handleExportar();
                }}
                type="button"
                disabled={exportRegistrosDeVisitas}
              >
                Exportar
              </ModalButton>
            </div>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default RegistroDeVisitasKPIModal;
